<nz-modal
  [nzWrapClassName]="'promotion-popup-window'"
  [(nzVisible)]="isVisible"
  [nzFooter]="null"
  [nzTitle]="undefined"
  [nzWidth]="620"
  [nzClosable]="false"
  [nzMaskClosable]="false"
  nzCentered
  (nzOnCancel)="handleClose()"
  (nzAfterOpen)="onModalAfterOpen()"
  [nzBodyStyle]="{ padding: '0' }"
>
  <ng-container *nzModalContent>
    <div *ngIf="activity" class="promo-modal">
      <!-- Carousel Track：可视区高度跟随当前 slide，避免内容少的活动下方留白 -->
      <div class="promo-carousel" [style.height]="carouselHeight ? carouselHeight + 'px' : null">
        <div class="promo-track" [style]="slideTrackStyle">
          <div class="promo-slide" *ngFor="let act of activityList; let i = index" #promoSlide>
            <!-- Hero Header -->
            <div class="promo-hero">
              <span class="promo-badge">
                <img class="promo-badge-icon" src="assets/promotion/benefits.png" alt="">
                限时专享福利
              </span>
              <h2 class="promo-hero-title">{{ act.activityName }}</h2>
              <p class="promo-hero-desc">买满即送卡券，海量积分轻松拿，兑换精美豪礼。</p>
            </div>

            <div class="promo-body">
              <!-- Activity Details -->
              <div class="promo-details-card">
                <div class="section-heading">
                  <span class="heading-bar heading-bar--dark"></span>
                  活动详情
                </div>
                <div class="details-highlight-box">
                  <!-- 正文使用 pre-wrap 渲染，标签与插值之间不能有模板缩进空白，否则会多出首行缩进 -->
                  <p #detailContent
                     class="details-highlight-text"
                     [class.details-highlight-text--clamped]="!expandedContentIds.has(act.activityId)">{{ act.activityContents }}<span
                      class="details-more-btn"
                      *ngIf="contentOverflowIds.has(act.activityId) && expandedContentIds.has(act.activityId)"
                      (click)="toggleContent(act.activityId)">收起</span></p>
                  <span
                    class="details-more-btn details-more-btn--corner"
                    *ngIf="contentOverflowIds.has(act.activityId) && !expandedContentIds.has(act.activityId)"
                    (click)="toggleContent(act.activityId)">更多</span>
                </div>
                <div class="details-meta-row">
                  <div class="meta-item">
                    <i nz-icon nzType="calendar" nzTheme="outline" class="meta-icon"></i>
                    <div class="meta-text">
                      <div class="meta-label">活动时间</div>
                      <div class="meta-value">{{ formatTimeRange(act) }}</div>
                    </div>
                  </div>
                  <div class="meta-item">
                    <i nz-icon nzType="clock-circle" nzTheme="outline" class="meta-icon"></i>
                    <div class="meta-text">
                      <div class="meta-label">奖励发放</div>
                      <div class="meta-value">{{ formatAwardTimeliness(act) }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Redemption Process -->
              <div class="promo-redemption-card">
                <div class="voucher-box">
                  <div class="voucher-card">
                    <img *ngIf="getAwardImageUrl(act) && !awardImgBroken.has(act.activityId)"
                         [src]="getAwardImageUrl(act)" [alt]="act.activityName" (error)="onAwardImageError(act)" />
                    <ng-container *ngIf="!getAwardImageUrl(act) || awardImgBroken.has(act.activityId)">
                      <i nz-icon nzType="gift" nzTheme="outline" class="voucher-empty-icon"></i>
                    </ng-container>
                  </div>
                  <div class="voucher-label">专属礼品卡券</div>
                </div>
                <div class="redemption-content">
                  <div class="section-heading">
                    <span class="heading-bar heading-bar--blue"></span>
                    兑换流程
                  </div>
                  <ol class="redemption-list">
                    <li><span class="step-num">01.</span><span class="step-desc">卡券次日自动发放至易加网账户</span></li>
                    <li><span class="step-num">02.</span><span class="step-desc">登录易加网小程序进入"卡券列表"查看</span></li>
                    <li><span class="step-num">03.</span><span class="step-desc">选择心仪礼品并提交兑换申请</span></li>
                    <li><span class="step-num">04.</span><span class="step-desc">礼品将按照收货地址进行配送</span></li>
                  </ol>
                </div>
              </div>

              <!-- Disclaimer -->
              <div class="promo-disclaimer">
                <p class="disclaimer-title">责任声明</p>
                <p class="disclaimer-text" *ngIf="act.disclaimer">{{ act.disclaimer }}</p>
                <p class="disclaimer-text" *ngIf="!act.disclaimer">* 本活动最终解释权归博世所有。礼品数量有限，先到先得，兑完即止。图片仅供参考，请以实物为准。如遇退货情况，需退回相应发放的卡券或等值积分。</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Left Arrow -->
      <button *ngIf="hasMultipleActivities" class="carousel-arrow carousel-arrow--left" (click)="prevSlide()">
        <i nz-icon nzType="left" nzTheme="outline"></i>
      </button>
      <!-- Right Arrow -->
      <button *ngIf="hasMultipleActivities" class="carousel-arrow carousel-arrow--right" (click)="nextSlide()">
        <i nz-icon nzType="right" nzTheme="outline"></i>
      </button>

      <!-- Dots -->
      <div class="carousel-dots" *ngIf="hasMultipleActivities">
        <span
          class="carousel-dot"
          *ngFor="let act of activityList; let i = index"
          [class.active]="i === activeSlideIndex"
          (click)="goToSlide(i)">
        </span>
      </div>

      <!-- Close Button -->
      <button class="promo-close-btn" (click)="handleClose()">
        <i nz-icon nzType="close" nzTheme="outline"></i>
      </button>

      <!-- CTA -->
      <div class="promo-cta">
        <button class="cta-button" (click)="goToPromotionList()">
          立即参与
          <i nz-icon nzType="arrow-right" nzTheme="outline"></i>
        </button>
      </div>
    </div>
  </ng-container>
</nz-modal>
